import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebhookSubscription, WebhookListItem } from 'app/webhooks/model/webhooks.model';
import { LimitsExceededResponse } from '../lead-generation/shared/domain/LimitsExceededResponse';

@Injectable({
  providedIn: 'root'
})
export class WebhooksService {
  constructor(private http: HttpClient) {}

  public getAll(): Observable<WebhookListItem[]> {
    return this.http.get<WebhookListItem[]>('/webhook/subscriptions');
  }

  public getTypes(): Observable<WebhookListItem[]> {
    return this.http.get<WebhookListItem[]>('/webhook/types');
  }

  public saveWebhook(webhook: WebhookSubscription): Observable<any> {
    return this.http.post('/webhook/subscriptions', webhook);
  }

  public checkIfLimitsExceeded(): Observable<LimitsExceededResponse> {
    return this.http.get<LimitsExceededResponse>('/webhook/subscriptions/limits-exceeded');
  }

  getSingle(id: number): Observable<WebhookSubscription> {
    return this.http.get<WebhookSubscription>(`/webhook/subscriptions/${id}`);
  }

  update(id: number, webhook: WebhookSubscription) {
    return this.http.put(`/webhook/subscriptions/${id}`, webhook);
  }

  activate(id: number) {
    return this.http.put(`/webhook/subscriptions/${id}/activate`, {});
  }

  deactivate(id: number) {
    return this.http.put(`/webhook/subscriptions/${id}/deactivate`, {});
  }

  delete(id: number) {
    return this.http.delete(`/webhook/subscriptions/${id}`);
  }
}
